module.exports = __webpack_public_path__ + "static/starofservice.com-d44f36cfa73e1c3db874df362f9e1f88.png";